/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Freeze_Start_LabelInputs */

const fr_membership_freeze_start_label = /** @type {(inputs: Membership_Freeze_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Début de la pause`)
};

/**

* @param {Membership_Freeze_Start_LabelInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_freeze_start_label = /** @type {((inputs?: Membership_Freeze_Start_LabelInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Freeze_Start_LabelInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_freeze_start_label(inputs)
});